module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "tutorial"
  }, [_c('el-row', {
    staticClass: "tutorial-row"
  }, [_c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-begin"
  }, [_vm._v("Begin")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-end"
  }, [_vm._v("End")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_vm._v("Path")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-obstacle"
  }, [_vm._v("Obstacle")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube"
  }, [_c('div', {
    staticClass: "parent",
    staticStyle: {
      "transform": "rotate(270deg)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }, [_vm._v("Visited")]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Parent\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube"
  }, [_c('div', {
    staticClass: "parent",
    staticStyle: {
      "transform": "rotate(270deg)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-path"
  }, [_vm._v("Path")]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Parent\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "H line-height-font-size"
  }, [_vm._v("10(H)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Heuristic\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "G line-height-font-size"
  }, [_vm._v("20(G)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Moving Cost\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "F line-height-font-size"
  }, [_vm._v("30(F)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Weight\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "S line-height-font-size"
  }, [_vm._v("10")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Visiting Index\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a503abd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorial.vue
// module id = 160
// module chunks = 1